import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { PageSizes } from "../../common/constants";
import { EntityIdObject, EntityObject } from "../../common/types";
import {
  CreateUpdateDynamicConfigProperty,
  DynamicConfigProperty,
  DynamicConfigPropertyFilterPageRequest,
  DynamicConfigPropertyFilterPageResult,
} from "./types";

const FILTER_CONFIG_PROPERTIES = ApiRequestAdapter.create("/config-properties", HttpMethod.GET);
const CREATE_CONFIG_PROPERTY = ApiRequestAdapter.create("/config-properties", HttpMethod.POST);
const UPDATE_CONFIG_PROPERTY = ApiRequestAdapter.create("/config-properties/{0}", HttpMethod.PUT);
const DELETE_CONFIG_PROPERTY = ApiRequestAdapter.create("/config-properties/{0}", HttpMethod.DELETE);

export const dynamicConfigApi = {
  filterConfigProperties: (
    request: DynamicConfigPropertyFilterPageRequest,
  ): AxiosPromise<DynamicConfigPropertyFilterPageResult> => {
    return apiService.get(FILTER_CONFIG_PROPERTIES.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  createConfigProperty: (request: CreateUpdateDynamicConfigProperty): AxiosPromise<DynamicConfigProperty> => {
    return apiService.post(CREATE_CONFIG_PROPERTY.url, request);
  },
  updateConfigProperty: (
    request: EntityObject<CreateUpdateDynamicConfigProperty>,
  ): AxiosPromise<DynamicConfigProperty> => {
    return apiService.put(UPDATE_CONFIG_PROPERTY.getParametrizedUrl(request.id), request.object);
  },
  deleteConfigProperty: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_CONFIG_PROPERTY.getParametrizedUrl(request.id));
  },
};

export const DEFAULT_FILTER_CONFIG_PROPERTIES_QUERY_PARAMS: Required<DynamicConfigPropertyFilterPageRequest> = {
  pageIndex: 0,
  pageSize: PageSizes.LARGE,
  keyword: "",
  ownedByIds: [],
};
